exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn_secondary {\n  white-space: nowrap;\n  min-width: 75px !important;\n  min-height: 30px !important;\n  line-height: 1.5em;\n  font-size: 14px;\n  margin-top: 3px;\n  margin-right: 10px;\n}\n\n.itemcode {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/render/grid-double-button-renderer.component.css
// module id = ../../../../../src/app/render/grid-double-button-renderer.component.css
// module chunks = main